import React from 'react';
import Button from '../../atoms/buttons/Button';
import { ButtonAction, ButtonType } from 'atoms/buttons/types/Button';

const styles = {
  width: 192,
  padding: '0 22px',
  fontWeight: 600,
  marginBottom: 20,
  marginTop: 20,
};

interface IJoinButtonActionProps {
  isDisabled?: boolean;
  buttonType?: ButtonType;
  onClick?: (event: React.MouseEvent) => void;
  label: string;
  customStyle?: React.CSSProperties;
  type?: ButtonAction;
  isDefault?: boolean;
}
const JoinActionButton: React.FC<IJoinButtonActionProps> = (props: IJoinButtonActionProps) => {
  const { isDisabled, onClick, label, buttonType = 'primaryRed', customStyle, type, ...rest } = props;

  return (
    <Button
      data-test-id="join-action-button"
      customStyle={{ ...styles, ...customStyle, ...{ opacity: isDisabled ? '0.7' : '1', fontSize: 14 } }}
      buttonType={buttonType}
      onClick={onClick}
      disabled={isDisabled}
      type={type}
      {...rest}
    >
      {label}
    </Button>
  );
};

export default JoinActionButton;
